const retirementResults = new WeakMap();

export const recordTaskRetirement = (history, taskId) => {
    retirementResults.get(history)?.clear();
    const clear = () => {
        retirementResults.delete(history);
        unlisten();
    };
    const unlisten = history.listen(location => {
        if (location.pathname !== '/fw-tasks') clear();
    });
    retirementResults.set(history, { taskId, clear });
};

export const consumeTaskRetirement = history => {
    const result = retirementResults.get(history);
    result?.clear();
    return result?.taskId ?? null;
};
